export enum OpenDirections {
    None,
    Self,
    Other,
    Both
}